import { useCallback, useEffect, useState } from "react";

import RemovedFromCampaignModal from "@/components/campaigns/RemovedFromCampaignModal";
import {
  consumeRemovedCampaignNotice,
  subscribeToRemovedCampaignNotice,
  type RemovedCampaignNotice,
} from "@/lib/removedCampaignNotice";

export default function RemovedFromCampaignNoticeWatcher() {
  const [notice, setNotice] = useState<RemovedCampaignNotice | null>(null);

  const tryConsume = useCallback(() => {
    setNotice((current) => {
      if (current) {
        return current;
      }
      return consumeRemovedCampaignNotice();
    });
  }, []);

  useEffect(() => {
    tryConsume();
    return subscribeToRemovedCampaignNotice(tryConsume);
  }, [tryConsume]);

  const handleClose = useCallback(() => {
    setNotice(null);
  }, []);

  return (
    <RemovedFromCampaignModal
      open={notice !== null}
      campaignName={notice?.name ?? null}
      onClose={handleClose}
    />
  );
}
